<template>
  <div style="padding: 20px" class="contenedorLogin">
    <div class="row" id="contentSpanIngreseCuenta">
      <span id="spanIngreseCuenta">CAMBIA TU CONTRASEÑA</span>
    </div>
    <form
      class="form-horizontal m-t-20"
      id="loginform"
      v-on:submit.prevent="enviarNuevasCredenciales"
    >
      <input
        name="__RequestVerificationToken"
        type="hidden"
        value="OHTz5bDiUfoY-GO10HHFKstq3fbeyWBQhqgUAgRijKwYs8i3pTSX04CYPdC9kYo-b0JU53PK2TF_LyQeHN41G-76HE2c65CP7rT0ovAU7Uo1"
      />
      <div class="container-fluid" id="loginDiv">
        <div
          class="row"
          style="padding-left: 10%; padding-right: 10%; padding-bottom: 30px"
        >
          <input
            id="UserName"
            name="UserName"
            placeholder="Contraseña"
            style="box-shadow: none; border-radius: 2px"
            value=""
            type="password"
            v-model="password"
            required
            :class="
              'textLoginPlaceholder form-control form-control-lg ' + classPass
            "
            aria-label="Password"
            aria-describedby="basic-addon1"
          />
        </div>
        <div
          class="row"
          style="padding-left: 10%; padding-right: 10%; padding-bottom: 30px"
        >
          <input
            id="Password"
            name="Password"
            placeholder="Repetir contraseña"
            style="box-shadow: none"
            type="password"
            v-model="password1"
            required
            :class="
              'textLoginPlaceholder form-control form-control-lg ' + classPass1
            "
            aria-label="Password"
            aria-describedby="basic-addon1"
          />
        </div>

        <div>
          <div v-for="(regla, index) in reglas" :key="'regla' + index">
            <p class="white">
              <i
                :class="regla.class + ' fas fa-check-circle'"
                v-if="regla.class == 'text-success'"
              ></i>
              <i v-else :class="regla.class + ' fas fa-exclamation-circle'"></i>
              {{ regla.text }}
            </p>
          </div>
        </div>

        <div class="row">
          <div
            class="col-lg-4 col-md-5 col-sm-5 col-xs-5"
            style="padding: 0px; padding-left: 10%;"
          >
            <button
              class="btn btnFullWhite"
              style="width: 105px"
              id="btnIngresar"
              type="submit"
              :disabled="!(classPass == classPass1 && classPass == 'is-valid')"
            >
              Enviar
            </button>
          </div>
          <div class="col" style="padding-left: 10%"><button
              class="btn btnFullWhite"
              style="width: 105px"
              @click="regresar()"
            >
              Volver
            </button></div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import VueJwtDecode from "vue-jwt-decode";
import { mapActions } from "vuex";
export default {
  props: ["token"],
  data() {
    return {
      usuario: "",
      password: "",
      password1: "",
      result: "",
      classPass: "is-invalid",
      classPass1: "is-invalid",
      reglas: [
        {
          text: "Longitud de contraseña: minimo 8 caracteres",
          isValid: (value) => {
            if (value.length >= 8) {
              return true;
            }
            return false;
          },
          class: "text-danger",
        },
        {
          text: "Caracteres numericos: minimo 2 numeros",
          isValid: (value) => {
            let bandera = 0;
            for (let i = 0; i < value.length; i++) {
              if (/^[0-9]+$/.test(value.charAt(i))) {
                bandera++;
                if (bandera == 2) {
                  return true;
                }
              }
            }
            return false;
          },
          class: "text-danger",
        },
        {
          text: "Caracteres de simbolos: minimo 1 caracter especial",
          isValid: (value) => {
            for (let i = 0; i < value.length; i++) {
              if (!/[a-zA-Z0-9]/.test(value.charAt(i))) {
                return true;
              }
            }
            return false;
          },
          class: "text-danger",
        },
        {
          text: "Letras mayúsculas: minimo 1 letra mayúscula",
          isValid: (value) => {
            for (let i = 0; i < value.length; i++) {
              if (/[A-Z]/.test(value.charAt(i))) {
                return true;
              }
            }
            return false;
          },
          class: "text-danger",
        },
        {
          text: "Letras minúsculas: minimo 1 letra minúscula",
          isValid: (value) => {
            for (let i = 0; i < value.length; i++) {
              if (/[a-z]/.test(value.charAt(i))) {
                return true;
              }
            }
            return false;
          },
          class: "text-danger",
        },
      ],
    };
  },
  methods: {
    regresar() {
      this.$emit("regresar");
    },
    enviarNuevasCredenciales() {
      let that = this;
      let data = VueJwtDecode.decode(this.token).data;
      if (
        this.password === this.password1 &&
        this.password != data.cve_empleado
      ) {
        this.$http
          .post("usuarios/restablecerUsuario", {
            password: this.password,
            cve_empleado: data.cve_empleado,
          })
          .then((respuesta) => {
            return respuesta.json();
          })
          .then((respuestaJson) => {
            if (respuestaJson.resp == "Excelente") {
              swal(respuestaJson.resp, "Usuario actualizado", "success");
              setTimeout(() => {
                that.regresar();
              }, 1500);
            } else {
              that.Listo();
              swal("!Ups¡", respuestaJson.resp, "error");
            }
          })
          .catch(function (error) {
            console.log("Error en Iniciar_Sesion", error);
            swal(
              "Problemas para conectarse",
              "Favor de revisar su conexión a internet (2)",
              "error"
            );
            that.Listo();
          });
      } else {
        if (this.password == data.cve_empleado) {
          swal(
            "Error de datos",
            "Favor de revisar que la contraseña no sea igual al numero de usuario: " +
              data.cve_empleado,
            "error"
          );
        } else {
          swal(
            "Error de datos",
            "Favor de revisar que las contraseñas coincidan",
            "error"
          );
        }
        that.Listo();
      }
    },
    Cargando() {
      var that = this;
      $(document).ready(function () {
        $(".preloader").show();
        that.result = "d-none";
      });
    },
    Listo() {
      var that = this;
      $(document).ready(function () {
        $(".preloader").hide();
        that.result = "";
      });
    },
  },
  watch: {
    password: function () {
      this.reglas.forEach((element) => {
        if (element.isValid(this.password)) {
          element.class = "text-success";
          return element;
        } else {
          element.class = "text-danger";
          return element;
        }
      });
      let rest = this.reglas.filter((element) => {
        return !element.isValid(this.password);
      });
      console.log(rest.length);
      if (rest.length > 0) {
        this.classPass = "is-invalid";
      }
      if (rest.length == 0) {
        this.classPass = "is-valid";
      }
    },
    password1() {
      if (this.password == this.password1) {
        this.classPass1 = "is-valid";
      } else {
        this.classPass1 = "is-invalid";
      }
    },
  },
  computed: {
    menu() {
      return this.$store.getters.getMenu;
    },
    firebase_config() {
      return this.$store.getters.getFirebase_Config;
    },
  },
  created() {
    //this.enviarNuevasCredenciales();
    //this.ConsultarClientes();
  },
  mounted() {
    var that = this;
    $("#customizer_color_menu").addClass("d-none");
    $("#ze-snippet").remove();
    /*
    if (that.clientes_autocomplete!=null) {
      that.autocomplete(document.getElementById("myInput"), that.clientes_autocomplete);
    }
    */
  },
};
</script>

<style scoped>
/**
  ////////FAMILY FONTS//////

 */
#parentHeaders {
  padding-left: 0px;
  padding-right: 0px;
}
#header1 {
  padding-left: 0;
}
#header2 {
  line-height: 40px;
  height: 50px !important;
  text-align: right;
}
#imgLogoTernium {
  float: left;
  margin-right: 40px;
}
input[type="radio"] {
  display: none;
}
label {
  font-family: "Trade Gothic LT";
  display: inline-block;
  font-weight: 100;
  opacity: 0.7;
}
#contentTOP {
  padding-left: 6%;
  padding-top: 40px;
  padding-right: 6%;
  position: relative;
  background: rgba(0, 0, 0, 0.3);
}
#imgLogoTernium {
  width: 141px;
  height: 49px;
}
@media (min-width: 1024px) and (max-width: 1365px) {
  #imgLogoTernium {
    width: 98px;
    height: 34px;
  }
}

#section1 {
  margin: 0;
  background-image: url(/static/assetsTernium/img/bg1.jpg);
  height: auto;
  width: 100%;
  background-size: cover;
}

@media (max-width: 1366px) {
  .spanHeader {
    /* text-transform: capitalize; */
    font-size: 0.8em;
    line-height: 15px;
    letter-spacing: 0px;
  }
}

@media (min-width: 1024px) and (max-width: 1365px) {
  .spanHeader {
    /* text-transform: capitalize; */
    font-size: 15px;
    line-height: 20px;
    letter-spacing: 0px;
  }
}
@media (min-width: 1023px) {
  .spanHeader {
    /* text-transform: capitalize; */
    font-size: 15px;
    line-height: 20px;
    letter-spacing: 0px;
  }
}
@media (min-width: 768px) {
  .spanHeader {
    /* text-transform: capitalize; */
    font-size: 12px;
    line-height: 15px;
    letter-spacing: 0px;
  }
}
.spanHeader {
  font-family: "Trade Gothic LT Bold No. 2";
  cursor: pointer;
  color: rgba(255, 255, 255, 0.9);
  margin-left: 20px;
}

#spanPlataformaServicios {
  font-family: "Trade Gothic LT Bold No. 2";
  cursor: pointer;
  color: rgba(255, 255, 255, 1);
  font-size: 18px;
}

.initView .row {
  margin-left: 0;
  margin-right: 0;
}
.contenedorTitulosLogin {
  margin-top: 0;
  margin-bottom: 0;
  height: 500px;
  padding-left: 0;
  padding-right: 0;
  height: 77vh;
  width: 87vw;
}
@media (min-width: 1023px) {
  .contenedorTitulosLogin {
    margin-top: 0;
    margin-bottom: 0;
  }
}
.box {
  position: relative;
  height: 67vh;
  width: 87vw;
  margin: 0;
  margin-top: 10px;
  padding: 0;
  border-style: solid;
  border-width: 0.05em;
  border-color: white;
  border-radius: 0;
}

@media only screen and (min-width: 1000px) {
  .box {
    margin: 0;
    margin-top: 45px;
  }
}

.top,
.bottom,
.left,
.right {
  position: absolute;
  -webkit-animation: 8s linear;
  -moz-animation: 8s linear;
  -o-animation: 8s linear;
  animation: 8s linear;
  -webkit-animation-timing-function: ease-in-out;
  -moz-animation-timing-function: ease-in-out;
  -o-animation-timing-function: ease-in-out;
  animation-timing-function: ease-in-out;
  -webkit-animation-fill-mode: forwards;
  -moz-animation-fill-mode: forwards;
  -o-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
  opacity: 0.5;
}

.top {
  top: 0;
  left: 0;
  height: 1px;
  -webkit-animation-name: top;
  -moz-animation-name: top;
  -o-animation-name: top;
  animation-name: top;
}
.bottom {
  bottom: 0;
  right: 0;
  height: 1px;
  -webkit-animation-name: bottom;
  -moz-animation-name: bottom;
  -o-animation-name: bottom;
  animation-name: bottom;
}
.left {
  bottom: 0;
  left: 0;
  width: 1px;
  -webkit-animation-name: left;
  -moz-animation-name: left;
  -o-animation-name: left;
  animation-name: left;
}
.right {
  top: 0;
  right: 0;
  width: 1px;
  -webkit-animation-name: right;
  -moz-animation-name: right;
  -o-animation-name: right;
  animation-name: right;
}
.contenedorTexto {
  padding-top: 80px;
  margin-bottom: 40px;
  padding-left: 5%;
  float: left;
  width: 100%;
}
@media (min-width: 1024px) and (max-width: 1365px) {
  .contenedorTexto {
    padding-top: 80px;
    margin-bottom: 40px;
  }
}
@media (min-width: 1023px) {
  .contenedorTexto {
    padding-top: 80px;
    margin-bottom: 40px;
  }
}
@media (min-width: 992px) {
  .contenedorTexto {
    padding-top: 40px;
    margin-bottom: 20px;
  }
}
@media (min-width: 700px) {
  .contenedorTexto {
    padding-top: 40px;
    margin-bottom: 20px;
  }
}

#svgContent {
  width: 2%;
  padding: 0;
  padding-top: 6px;
}
#arrowSVG {
  fill: white;
}
.contenedorTexto2,
#svgContent {
  margin-bottom: 40px;
  padding-top: 5px;
}
@media (min-width: 1024px) and (max-width: 1365px) {
  .contenedorTexto2 {
    margin-bottom: 40px;
  }
}

h1 {
  color: white;
  font-family: "Trade Gothic LT Bold Condensed";
  font-size: 75px;
  line-height: 80px;
  letter-spacing: -1px;
}
.contenedorLogin {
  display: block !important;
  position: absolute;
  background-size: cover;
  right: 13%;
  display: none;
  width: 425px;
  bottom: -10px;
  background-image: -o-linear-gradient(45deg, #f30, #f90);
  background-image: linear-gradient(45deg, #f30, #f90);
  padding-bottom: 2em;
}
@media only screen and (min-width: 1224px) {
  .contenedorLogin {
    bottom: -20px;
  }
}
@media (min-width: 992px) {
  .contenedorLogin {
    bottom: -60px;
  }
}
@media (min-width: 700px) {
  .contenedorLogin {
    bottom: -20px;
  }
}

#contentSpanIngreseCuenta {
  padding-top: 25px;
  padding-left: 10%;
  padding-right: 10%;
  padding-bottom: 25px;
}

#spanIngreseCuenta {
  font-family: Trade Gothic LT;
  font-size: 21px;
  color: #fff;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.14;
  letter-spacing: normal;
}

#loginDiv {
  padding-left: 0px;
  padding-right: 0px;
  padding-bottom: 20px;
}

.textLoginPlaceholder {
  color: rgba(255, 255, 255, 0.9) !important;
  border-radius: 2px;
  border-top-right-radius: 4px;
  border: 1px solid rgba(255, 255, 255, 0.9);
  background: none;
  height: 40px;
  width: 100%;
  padding: 6px 12px;
  font-family: "Trade Gothic LT Bold No. 2";
}

.textLoginPlaceholder::placeholder {
  color: #fff !important;
}

.btnFullWhite {
  height: 42px;
  border-radius: 25px;
  width: 100%;
  padding: 0px;
  background-color: white;
  color: #ff3300;
  outline: none;
  font-weight: 600;
  text-transform: uppercase;
}
.spanLinkLogin {
  font-family: "Trade Gothic LT";
  cursor: pointer;
  color: rgba(255, 255, 255, 0.9);
  font-size: 11px !important;
}
@media (max-width: 1366px) {
  .spanLinkLogin {
    /* text-transform: capitalize; */
    font-size: 0.8em;
    line-height: 17px;
    letter-spacing: 0px;
  }
}

@media (min-width: 1024px) and (max-width: 1365px) {
  .spanLinkLogin {
    /* text-transform: capitalize; */
    font-size: 12px;
    line-height: 17px;
    letter-spacing: 0px;
  }
}
@media (min-width: 768px) {
  .spanLinkLogin {
    /* text-transform: capitalize; */
    font-size: 9px;
    line-height: 13px;
    letter-spacing: 0px;
  }
}

.contenedorMainFunctions {
  width: 100%;
  float: left;
  padding: 6%;
  background-color: #fff;
}

#spanFuncionesPrincipales {
  color: black;
  font-size: 50px;
  font-family: "Trade Gothic LT Bold Condensed";
}

.subtitulos2 {
  color: #7b7b7b;
  font-size: 18px;
  line-height: 1.39;
  font-family: "Trade Gothic LT";
}

@media (min-width: 700px) {
  .subtitulos2 {
    font-size: 18px;
  }
}

.contenedorConfiguracion {
  width: 100%;
  float: left;
  padding: 6%;
  background-color: #f6f6f6;
}

.contenedorConfiguracion h5 {
  font-family: "Trade Gothic LT Bold No. 2";
}
.contenedorConfiguracion .col-xs-4 {
  padding-left: 2em;
  padding-right: 2em;
}

@media (min-width: 1366px) and (max-width: 1920px) {
  .contenedorConfiguracion h5 {
    font-size: 45px;
    line-height: 48px;
    letter-spacing: -1.5px;
  }
}

@media (min-width: 768px) {
  .contenedorConfiguracion h5 {
    font-size: 30px;
    line-height: 30px;
    letter-spacing: -1.5px;
  }
}

.backgroundNegro {
  height: auto;
  position: relative;
  width: 100%;
  right: 0;
  float: left;
  padding: 6% 6% 11%;
  background-image: -webkit-gradient(
    linear,
    left top,
    left bottom,
    from(#1e2533),
    to(#010d1a)
  );
  background-image: -o-linear-gradient(top, #1e2533, #010d1a);
  background-image: linear-gradient(180deg, #1e2533, #010d1a);
}

.ventajas {
  color: #fff;
  font-size: 45px;
  font-family: "Trade Gothic LT Bold Condensed";
}
.subtitulos {
  color: white;
  font-family: "Trade Gothic LT Bold Condensed";
  font-size: 20px;
  position: absolute;
  width: 15em;
  top: 55px;
}
.textoAdvantages {
  font-family: "Trade Gothic LT Bold Condensed";
  color: #2f3339;
  font-size: 140px;
}
.body3 {
  font-family: "Trade Gothic LT";
  color: rgba(255, 255, 255, 1);
  font-size: 15px;
  position: absolute;
  width: 15em;
  top: 95px;
}
.contenedorFooter {
  background-image: -webkit-gradient(
    linear,
    left top,
    left bottom,
    from(#1e2533),
    to(#010d1a)
  );
  background-image: -o-linear-gradient(top, #1e2533, #010d1a);
  background-image: linear-gradient(180deg, #1e2533, #010d1a);
}

.contenedorFooter {
  background-image: -webkit-gradient(
    linear,
    left top,
    left bottom,
    from(#1e2533),
    to(#010d1a)
  );
  background-image: -o-linear-gradient(top, #1e2533, #010d1a);
  background-image: linear-gradient(180deg, #1e2533, #010d1a);
}

.spanFooter {
  cursor: pointer;
  font-family: "Trade Gothic LT";
  font-size: 14px;
  line-height: 1.5;
  display: inline-block;
}
@media (max-width: 1366px) {
  .spanFooter {
    font-size: 0.8em;
  }
}
@media (min-width: 1024px) and (max-width: 1365px) {
  .spanFooter {
    font-size: 15px;
  }
}
@media (min-width: 1023px) {
  .spanFooter {
    font-size: 15px;
  }
}
@media (min-width: 768px) {
  .spanFooter {
    font-size: 12px;
  }
}

.logoNegroTernium {
  width: 151.3px;
  height: 52.8px;
}

.logoNegroTernium {
  width: 151.3px;
  height: 52.8px;
}
.logoNegroTernium {
  vertical-align: middle;
}
.logoNegroTernium {
  border: 0;
}

.cuadrosText {
  padding-right: 2em;
  padding-left: 2em;
}
.text-white {
  height: 15em;
  background-color: #fff;
}
.white {
  color: #ffffff !important;
}
</style>




// WEBPACK FOOTER //
// src/components/AppLogin/Login/RestablecerUsuario.vue